import linkifyHtml from 'linkify-html'
import { emojiToEmailHtmlReplacer, emojiToHtmlReplacer, getEmojiRegexp } from '@/utils/emojiHelpers'
import { getTagsRegexp } from '@/services/forms/tmTiptap/utils/getTagsRegexp'
import { createParagraphContent, createTagContent } from '@/services/forms/tmTiptap/utils/createContent'
import { HTML_DATA_ATTRIBUTE, linkMarkName } from '@/services/forms/tmTiptap/const'
import { getHtmlService } from '@/core/container/ioc'
import { textContainsHtmlTags } from '@/utils/string/html/textContainsHtmlTags'

export const createContentFromTemplate = (
  templateText: string,
  replaceLinksWithSpan = true,
  replaceToEmailEmoji = false,
) =>
  templateText
    .split(/\n/)
    .map((line, i) => {
      // Find all links in the line and replace them with their HTML equivalent
      line = processLinks(line, replaceLinksWithSpan)

      // Split the text into lines and map each line to HTML content
      // Replace all tags with their HTML equivalent
      line = line.replace(getTagsRegexp('g'), (_: string, tag: string) => createTagContent(tag))

      // Replace all emojis with their HTML equivalent
      line = line.replace(getEmojiRegexp(false, true), (_: string, emoji: string) =>
        replaceToEmailEmoji ? emojiToEmailHtmlReplacer(emoji) : emojiToHtmlReplacer(emoji),
      )

      return createParagraphContent(line)
    })
    .join('')

const processLinks = (line: string, replaceWithSpan = false) => {
  const hasTagsBeforeProcessing = textContainsHtmlTags(line)
  const withLinks = linkifyHtml(line, {
    ignoreTags: ['a'],
    tagName: replaceWithSpan ? 'span' : 'a',
    target: replaceWithSpan ? undefined : '_blank',
    attributes: replaceWithSpan ? { [HTML_DATA_ATTRIBUTE]: linkMarkName } : undefined,
  })
  if (!replaceWithSpan || !hasTagsBeforeProcessing) {
    return withLinks
  }

  const parsed = getHtmlService().parseHTML(withLinks)
  const links = parsed.querySelectorAll('a')
  links.forEach((link) => {
    const span = document.createElement('span')
    span.setAttribute(HTML_DATA_ATTRIBUTE, linkMarkName)
    span.innerHTML = link.innerHTML
    link.replaceWith(span)
  })
  return parsed.body.innerHTML
}
